module.exports = __webpack_public_path__ + "img/vue2-arriere_vert.4020f4d7.png";